import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApplicationProgressResponse } from '@core/interfaces/api-responses';
import { AppConstants } from '@core/constants/app';

@Injectable({
  providedIn: 'root',
})
export class ApplicationProgressSharedService {

  private subject = new BehaviorSubject<ApplicationProgressResponse>(null);
  private readonly data$: Observable<ApplicationProgressResponse>;

  constructor() {
    this.data$ = this.subject.asObservable();
  }

  sendData(data: ApplicationProgressResponse) {
    const steps = AppConstants.getStepsApiMapping();
    data.lastStep = data.lastStep.replace(/_/g, '-');
    data.completedSteps = data.completedSteps.map(item => item.replace(/_/g, '-'))
      .sort((a, b) => steps.indexOf(a) - steps.indexOf(b));
    this.subject.next(data);
  }

  clearData() {
    this.subject.next(null);
  }

  getData(): Observable<ApplicationProgressResponse> {
    return this.data$;
  }
}
